<template>
  <div class="row">
    <div class="col-md-12" :class="id === 'insurance' ? '' : [validatedSectionClass, generalClass]">
      <div :class="id === 'insurance' ? '' : 'row'">
        <div class="address-components" :class="id === 'insurance' ? '' : 'col-md-10 col-md-offset-1'">
          <div class="row">
    <div :class="this.$store.state.requirements['address2'] && id !== 'insurance' || this.$store.state.requirements['insured_address2'] && id === 'insurance' ? 'col-md-6 col-xs-12' : 'col-md-12 col-xs-12'">
      <div :id="id + '.components.delivery_line_1'">
        <label :for="id + '.components.delivery_line_1.value'" v-if="suggestions.length > 1" style="font-style: italic; color: #77ab59; overflow: hidden; white-space: nowrap;">
          {{computeCaption(this.fields_en['keep_typing'], this.$store.state.lang.value.toLowerCase())}}
        </label>
        <label :for="id + '.components.delivery_line_1.value'" v-else
               :class="checkRequired ? 'required' : ''" v-html="computeReportableCaption('address', this.fields_en['address_line_1'], this.$store.state.lang.value.toLowerCase())">
        </label>
      </div>
      <el-input aria-label="address" :id="id + '.components.delivery_line_1.value'"
                :disabled="(disabled || (force_valid_address && !$store.state.international && smarty_street_selected))"
                :class="disabled ? 'disabled-class' : '' "
                @input="lookup"
                :name="'delivery_line_1_' + wizardStep"
                @select="streetAddress"
                v-model="components.delivery_line_1"
                onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
      </el-input>
    </div>
            <div class="col-md-6 col-xs-12" v-if="id === 'insurance' ? this.$store.state.requirements['insured_address2'] : this.$store.state.requirements['address2']">
              <div :id="id + '.delivery_line_2'">
                <label v-if="id !== 'insurance'">
                  <b>{{ computeReportableCaption('address2', this.fields_en['address_line_2'], this.$store.state.lang.value.toLowerCase()) }}</b>
                </label>
                <label v-else>
                  <b>{{ computeReportableCaption('insured_address2', this.fields_en['address_line_2'], this.$store.state.lang.value.toLowerCase()) }}</b>
                </label>
              </div>
              <el-input aria-label="address" :id="id + '.delivery_line_2'"
                        :name="'address-line2-' + wizardStep"
                        :disabled="disabled"
                        v-model="delivery_line_2"
                        onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
              </el-input>
              <div class="default-grey font-small"  v-html="id === 'insurance' ? (getFieldDescription('insured_address2')) || '' : getFieldDescription('address2') || ''"></div>
            </div>
          </div>
    <div style="min-height: 175; max-height: 175; background-color: transparent; overflow: hidden">
      <div v-show="suggestions.length" style="border: 1px solid #DCDFE6; margin-top: 4px;">
        <template v-for="suggestion in suggestions">
          <el-button
            size="mini"
            class="suggestion-button"
            @click="streetAddress(suggestion)">{{suggestion.value}}
          </el-button>
        </template>
        <el-button
          v-if="!force_valid_address"
          size="mini"
          class="suggestion-button"
          style="color: #ff0000;"
          @click="manually"
          @blur.native.capture="manually"> {{computeCaption(this.fields_en['manually_input'], this.$store.state.lang.value.toLowerCase())}}
        </el-button>
      </div>
      <div v-show="!suggestions.length">
        <div>
          <label :for="id + '.components.city_name.value'" :id="id + '.components.city_name'" :class="checkRequired ? 'required' : ''">
            {{computeCaption(this.fields_en['city'], this.$store.state.lang.value.toLowerCase())}}
          </label>
          <el-input
            aria-label="Address City"
            :disabled="disabled || (force_valid_address && !$store.state.international)"
            :class="disabled ? 'disabled-class' : '' "
            :id="id + '.components.city_name.value'"
            :name="'city_name_' + wizardStep"
            size="small"
            @input="setOriginalName(components)"
            v-model="components.city_name"
            onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
          </el-input>
        </div>
        <div>
          <el-row :gutter="10">
            <el-col :span="8">
              <label :id="id + '.components.state_abbreviation'" :class="checkRequired && !this.$store.state.international ? 'required' : ''">
                {{computeCaption(this.fields_en['state'], this.$store.state.lang.value.toLowerCase())}}
              </label><br>
              <el-select v-if="!this.$store.state.international"
                         size="small"
                         :disabled="disabled || (force_valid_address && !$store.state.international)"
                         :class="disabled ? 'disabled-class' : '' "
                         :name="'state_abbreviation_' + wizardStep"
                         clearable
                         filterable
                         @change="setOriginalName(components)"
                         v-model="components.state_abbreviation">
                <el-option
                  v-for="state_abbreviation in state_abbreviations"
                  :key="state_abbreviation"
                  :label="state_abbreviation"
                  :value="state_abbreviation">
                </el-option>
              </el-select>
              <el-input v-if="this.$store.state.international"
                        :disabled="disabled || (force_valid_address && !$store.state.international)"
                        size="small"
                        maxlength="5"
                        :name="'state_abbreviation_' + wizardStep"
                        @input="setOriginalName(components)"
                        v-model="components.state_abbreviation"
                        onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
              </el-input>
            </el-col>
            <el-col :span="8">
              <label :for="id + '.components.zipcode'" :class="checkRequired && !this.$store.state.international ? 'required' : ''">
                {{computeCaption(this.fields_en['zip_code'], this.$store.state.lang.value.toLowerCase())}}
              </label>
              <el-input
                :id="id + '.components.zipcode'"
                aria-label="Address ZIP Code"
                :disabled="disabled || (force_valid_address && !$store.state.international)"
                :class="disabled ? 'disabled-class' : '' "
                :name="'zipcode_' + wizardStep"
                size="small"
                maxlength="5"
                @input="setOriginalName(components)"
                v-model="components.zipcode"
                onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
              </el-input>
            </el-col>
            <el-col :span="8">
              <label :for="id + '.components.plus4_code'">
                {{computeCaption(this.fields_en['plus4_code'], this.$store.state.lang.value.toLowerCase())}}
              </label>
              <el-input
                :id="id + '.components.plus4_code'"
                aria-label="Address Plus4 Code"
                :disabled="disabled || (force_valid_address && !$store.state.international)"
                :class="disabled ? 'disabled-class' : '' "
                :name="'plus4_code' + wizardStep"
                size="small"
                maxlength="4"
                @input="setOriginalName(components)"
                v-model="components.plus4_code"
                onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
              </el-input>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row :gutter="10">
            <el-col :span="16">
              <label :for="id + '.components.county'" :class="checkRequired ? 'required' : ''">
                {{computeCaption(this.fields_en['county'], this.$store.state.lang.value.toLowerCase())}}
              </label>
              <el-input
                :id="id + '.components.county'"
                aria-label="Address County"
                :disabled="disabled || (force_valid_address && !$store.state.international)"
                :class="disabled ? 'disabled-class' : '' "
                :name="'county_' + wizardStep"
                size="small"
                @input="setOriginalName(components)"
                v-model="components.county"
                onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
              </el-input>
            </el-col>
            <el-col :span="8">
              <label :for="id + '.components.country.value'" :class="checkRequired ? 'required' : ''">
                {{computeCaption(this.fields_en['country'], this.$store.state.lang.value.toLowerCase())}}
              </label>
              <el-input
                aria-label="Address Country"
                :disabled="disabled || (force_valid_address && !$store.state.international)"
                :class="disabled ? 'disabled-class' : '' "
                :id="id + '.components.country.value'"
                :name="'country_' + wizardStep"
                size="small"
                @input="setOriginalName(components)"
                v-model="components.country"
                onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
              </el-input>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div style="padding-top: 3px">
      <small v-if="address_obj && address_obj.smartystreets_id" style="float: left; color: rgba(0, 0, 0, 0.3)">{{'ID: ' + address_obj.smartystreets_id}}</small>
      <el-button :disabled="disabled" :class="disabled ? 'disabled-class' : ''" class="clear-button" style="" @click="clearComponents">{{computeCaption(this.fields_en['clear'], this.$store.state.lang.value.toLowerCase())}}</el-button>
    </div>
      </div>
      </div>
    <div class="default-grey font-small" :class="id === 'insurance' ? '' : 'col-md-offset-1'"  v-html="(id === 'insurance' ? getFieldDescription('insured_address') : getFieldDescription('address')) || ''"></div>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import _ from "lodash"
import { Col, Row, Input, DatePicker, Autocomplete, Button, RadioGroup, Radio, RadioButton} from 'element-ui'
import {TranslationsUtils} from '../../../../../utils/Translations.js'
import {AccessionUtils} from '../../../../../utils/AccessionDetailsProcessing'
import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
const querystring = require('querystring')

export default {
  mixins: [TranslationsUtils, AccessionUtils, SettingsUtils],
  components: {
    [DatePicker.name]: DatePicker,
    [Button.name]: Button,
    [Autocomplete.name]: Autocomplete,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input,
    [Row.name]: Row,
    [Col.name]: Col
  },
  name: 'Address',
  props: ['id', 'address_obj', 'componentsInsurance', 'wizardStep', 'checkRequired', 'isDisabled', 'same_address2'],
  data () {
    return {
      smarty_street_selected: false,
      generalClass: 'general-inactive-section',
      validatedSectionClass: '',
      fields_en: {
        clear: 'Clear',
        manually_input: 'Manually input address',
        keep_typing: 'Keep typing to narrow the search results',
        address_line_1 :'Address Line 1',
        address_line_2 :'Address Line 2',
        disclaimer: 'Disclaimer',
        city: 'City',
        state: 'State',
        zip_code: 'Zip Code',
        plus4_code: 'Plus4 Code',
        county: 'County',
        country: 'Country'
      },
      disabled: this.isDisabled || false,
      smartystreets_mapping: {
        delivery_line_1: "delivery_line_1",
        city_name: "components.city_name",
        county: "metadata.county_name",
        state_abbreviation: "components.state_abbreviation",
        zipcode: "components.zipcode",
        plus4_code: "components.plus4_code",
        county_fips: "metadata.county_fips",
      },
      smartystreets_key: this.$store.state.configs.SMARTYSTREETS_KEY,
      delivery_line_2: '',
      components: {
        name: '',
        original_name: '',
        delivery_line_1: '',
        city_name: '',
        county: '',
        state_abbreviation: '',
        zipcode: '',
        plus4_code: '',
        county_fips: '',
        country: ''
      },
      suggestions: [],
      manual: false,
      state_abbreviations: [
        'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL',
        'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH',
        'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM',
        'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC',
        'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'
      ],
      nationality: 'US'
    }
  },
  created () {
    if (this.address_obj) {
      this.components = this.address_obj.components
      if (this.address_obj.smartystreets_id) {
        this.getAddressComponents()
      }
    }
    if (this.same_address2) {
      this.delivery_line_2 = this.same_address2
    }
    let token = localStorage.getItem('token')
    if (token) {
      if (Object.keys(this.componentsInsurance).length > 0) {
        this.components = this.componentsInsurance
      }
    }
    if (this.wizardStep === 'insurance') {
      if(this.componentsInsurance !== '') {
        this.components = this.componentsInsurance
      } else {
        this.components = {
          name: '',
          original_name: '',
          delivery_line_1: '',
          city_name: '',
          county: '',
          state_abbreviation: '',
          zipcode: '',
          plus4_code: '',
          county_fips: '',
          country: ''
        }
      }
    }
  },
  computed: {
    force_valid_address () {
      return this.$store.state.configs.FORCE_VALID_ADDRESS
    }
  },
  watch: {
    '$store.state.international': {
      handler: function (after, before) {
        this.validatedSectionClass = ''
        this.generalClass = 'general-inactive-section'
        if (this.$store.state.international) {
          this.nationality = 'International'
        } else {
          this.nationality = 'US'
        }
      }
    },
    address_obj (newVal, oldVal) {
      if (!newVal) {
        this.clearComponents()
      } else {
        this.components = this.address_obj.components
        if (!this.disabled && this.address_obj.smartystreets_id) {
          this.getAddressComponents()
        }
      }
    },
    'components.original_name' (newVal, oldVal) {
      this.address_obj ? this.$emit('input', newVal) : null
    },
    'delivery_line_2': {
      handler (value) {
        this.$emit('updateAddress2', value)
        if (this.id !== 'insurance') {
          this.$store.state.dataForInsurance.address2 = value
        }
      }
    },
    'same_address2': {
      handler (value) {
        this.delivery_line_2 = value
      }
    },
    components: {
      handler(val){
        this.$emit('updateAddress', this.components)
        if (this.checkRequirement('address')) {
          let excludedValues = []
          if (this.$store.state.international) {
            excludedValues = ['name', 'original_name', 'plus4_code', 'zipcode', 'state_abbreviation', 'county_fips']
          } else {
            if (this.force_valid_address) {
              excludedValues = ['name', 'original_name', 'plus4_code']
            } else {
              excludedValues = ['name', 'original_name', 'plus4_code', 'county_fips']
            }
          }
          let flag = true
          for (let iterator in this.components) {
            if (!excludedValues.includes(iterator)) {
              if (this.components[iterator] === '') {
                flag = false
              }
            }
          }
          if (flag) {
            this.validatedSectionClass = 'validated-section-class'
            this.generalClass = 'general-inactive-section'
          } else {
            this.validatedSectionClass = 'invalid-section-class'
            this.generalClass = 'general-invalid-section'
          }
        } else {
          this.validatedSectionClass = 'validated-section-class'
          this.generalClass = 'general-inactive-section'
        }
        if (Object.values(this.components).every(field => field !== '')) {
          this.smarty_street_selected = true
        } else {
          this.smarty_street_selected = false
        }
      },
      deep: true
    },
    componentsInsurance() {
      if (this.componentsInsurance !== '') {
        this.components = this.componentsInsurance
      } else {
        this.components = {}
        this.disabled = false
      }
    },
    'isDisabled' : {
      handler (before, after) {
        this.disabled = this.isDisabled
      }
    },
    '$store.state.userData.address': {
      async handler (value) {
        let addressComponents = []
        if (this.$store.state.userData.address_scanned) {
          addressComponents = value.split(',');
          await this.lookup(addressComponents[0])
          if (this.suggestions.length) {
            this.streetAddress(this.suggestions[0])
          } else {
            this.components.delivery_line_1 = addressComponents[0]
            this.components.city_name = addressComponents[1]
            this.components.state_abbreviation = addressComponents[2]
            let zipCode = addressComponents[3]
            if (zipCode.length === 10) {
              this.components.zipcode = zipCode.substring(0,6)
              this.components.plus4_code = zipCode.substring(6,10)
            }
          }
          this.$emit('updateAddress', this.components)
        }
      }
    }
  },
  methods: {
    validate () {
      if (this.$store.state.international) {
        let fields = ['delivery_line_1', 'city_name', 'county', 'country']
        for (let i = 0; i < fields.length; i++) {
          if (this.components[fields[i]] === '') {
            document.getElementsByName(fields[i] + '_' + this.wizardStep)[0].focus()
            return false
          }
        }
      } else {
        let fields = ['delivery_line_1', 'city_name', 'state_abbreviation', 'zipcode', 'county', 'country']
        for (let i = 0; i < fields.length; i++) {
          if (this.components[fields[i]] === '') {
            document.getElementsByName(fields[i] + '_' + this.wizardStep)[0].focus()
            return false
          }
        }
      }
      return true
    },
    setOriginalName(components, subject, field) {
      this.setName(components)
      components.original_name = ""
      if (
        !components.delivery_line_1 &&
        !components.city_name &&
        !components.state_abbreviation &&
        !components.zipcode &&
        !components.plus4_code &&
        !components.county &&
        !components.country
      )
        return

      components.original_name += components.delivery_line_1 + ", "
      components.original_name += components.city_name + ", "
      components.original_name += components.state_abbreviation + (components.state_abbreviation && (components.zipcode || components.plus4_code) ? " " : "")
      components.original_name += components.zipcode + (components.plus4_code ? "-" : "")
      components.original_name += components.plus4_code + ", "
      components.original_name += components.county + ", "
      components.original_name += components.country

      if (subject && field) subject[field] = components.original_name
    },
    setName(components) {
      components.name = "";
      if (!components.delivery_line_1 && !components.city_name && !components.state_abbreviation && !components.zipcode && !components.plus4_code && !components.country)
        return
      components.name += components.delivery_line_1 + ", "
      components.name += components.city_name + ", "
      components.name += components.state_abbreviation + (components.state_abbreviation && (components.zipcode || components.plus4_code) ? " " : "")
      components.name += components.zipcode + (components.plus4_code ? "-" : "");
      components.name += components.plus4_code + ", "
      components.name += components.country
    },
    lookup: _.throttle(async function(search) {
      this.setOriginalName(this.components)
      //   if (!_.get(this.config, 'smarty_streets.autocomplete', false)) {
      //     return
      //   }

      if (!search) {
        this.suggestions = []
        this.manual = false
        return
      }

      if (this.manual) {
        return
      }

      let url = 'https://smartystreets-pro.limsabc.com/app/'
      let query = querystring.stringify({
        'key': this.smartystreets_key,
        'search': search,
        'max_results': 5
      })
      const uninterceptedAxiosInstance = axios.create()
      await uninterceptedAxiosInstance
        .get(url + '?' + query)
        .then(response => {
          this.suggestions = []

          if (response.data.suggestions) {
            response.data.suggestions.forEach((suggestion) => {
              this.suggestions.push({
                value: suggestion.street_line + ', ' + suggestion.city + ', ' + suggestion.state + ' ' + suggestion.zipcode,
                suggestion: suggestion
              })
            })
            const ua = navigator.userAgent
            if (/android/i.test(ua)) {
              this.$refs.delivery_line_1.blur()
            }
          }
        })
        .catch(error => {
          console.log('Error getting smartystreets street address: ' + error)
        })
    }, 300),

    streetAddress (item) {
      this.suggestions = []
      this.manual = false
      this.clearComponents()
      let url = 'https://us-street.api.smartystreets.com/street-address'
      let query = querystring.stringify({
        'key': this.smartystreets_key,
        'street': item.suggestion.street_line,
        'city': item.suggestion.city,
        'state': item.suggestion.state
      })

      axios
        .get(url + '?' + query)
        .then(response => {
          if (response.data.length) {
            Object.entries(this.smartystreets_mapping).forEach(([key, value]) => {
              this.components[key] = _.get(response.data[0], value, '')
            })
            this.components.country = 'US'
            this.setOriginalName(this.components)

            this.$nextTick(() => { document.getElementById(this.id + '.components.country.value').focus() })
          }
        })
        .catch(error => {
          console.log('Error getting smartystreets street address: ' + error)
        })
      if (this.force_valid_address && !this.$store.state.international) {
        this.smarty_street_selected = true
      }
    },
    manually () {
      this.manual = true
      if (this.suggestions.length === 1) {
        this.streetAddress(this.suggestions[0])
      } else {
        this.suggestions = []
      }
      this.$nextTick(() => { document.getElementById(this.id + '.components.city_name.value').focus() })
    },
    getAddressComponents () {
      let url = this.ABCGet('Smartystreets')
      let data = querystring.stringify({
        filter: JSON.stringify([['id', '=', this.address_obj.smartystreets_id]])
      })
      axios
        .post(url, data)
        .then(response => {
          Object.entries(this.components).forEach(([key, value]) => {
            // let val = _.get(response.data.data, [0, key])
            this.components[key] = val ? val : ''
          })
          if (!this.components.delivery_line_1) {
            this.setAddressLine1()
          }
        })
        .catch(error => {
          this.userMessage('Error getting address components: ' + this.errorMessage(error), 'error')
        })
    },

    clearComponents () {
      this.suggestions = []
      this.manual = false

      Object.entries(this.components).forEach(([key, value]) => {
        this.components[key] = ''
      })

      this.smarty_street_selected = false
    },

    setAddressLine1 () {
      this.components.delivery_line_1 += this.components.primary_number + (this.components.primary_number && this.components.street_name ? ' ' : '')
      this.components.delivery_line_1 += this.components.street_name
    },

    required (field) {
      //   return _.get(this.required_fields, [field, 'required'], false)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/sass/paper/variables';
.suggestion-button {
  margin: unset !important;
  border: unset;
  border-radius: unset;
  width: 100%;
  height: 25px;
  text-align: left;
}
.disabled-class {
  color: grey !important;
  background-color: lightgrey !important;
}
.clear-button {
  float: right;
  background: white;
}
.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/Sections/Address.vue